import { Component, OnDestroy, OnInit } from '@angular/core';
import { PartyType } from 'app/event/models/party-type';
import { SummaryRecordTypeEnum } from 'app/event/models/summary-record-type.enum';
import { EventUtils } from 'app/event/utils/event-utils';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { Subscription } from 'rxjs/Subscription';
import { MenuStore } from '../../../menus/service/menu.store';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';

@Component({
  selector: 'pioneer-vendor-rsvp-page',
  templateUrl: './vendor-rsvp-page.component.html',
  styleUrls: ['./vendor-rsvp-page.component.css']
})
export class VendorRsvpComponent implements OnInit, OnDestroy {

  onyxEvent: OnyxEvent;

  public headerRecordType: SummaryRecordTypeEnum;

  public total: string;

  eventSubscription$: Subscription = new Subscription();

  constructor(
    private menuStore: MenuStore,
    private eventStore: EventStore,
    private authenticationStore: AuthenticationStore
  ) { }

  ngOnInit() {

    this.eventSubscription$ = this.eventStore.selectedEvent.subscribe((event: OnyxEvent) => {
      this.onyxEvent = new OnyxEvent(event);
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())
        , this.onyxEvent.eventProperty.subscriber);
    });

    this.headerRecordType = SummaryRecordTypeEnum.RSVP;
    this.total = 'total';

    this.checkMoreThanOneVendorExpanded();
  }

  ngOnDestroy() {
    this.eventSubscription$.unsubscribe();
  }

  getEventProperties() {
    return this.onyxEvent.eventVendors.filter(vendor => vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY');
  }

  showTotalSummary() {
    return this.getEventProperties().length > 1;
  }

  private checkMoreThanOneVendorExpanded() {
    let expanded = false;

    this.getEventProperties().forEach(function (party) {
      if (!expanded && party.isExpanded) {
        expanded = true;
      } else if (expanded) {
        party.isExpanded = false;
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-page/vendor-rsvp-page.component.ts